export default __webpack_public_path__ + "static/media/5 Mueble aglomerado televisor.7d35fa2e.jpeg";